import React, { Component, useState, useEffect, useMemo } from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { IconButton } from '@material-ui/core';
import './VettingCalendar.css';
import { Form, Input, Button, Spin, Alert, Select, Card, Row, Col, Typography } from 'antd';
import axios from 'axios';
import { ApiConstant } from '../../../../constants';
import eventIcon from '../../../../../assets/img/event.png';
import { pushLog2DV2LogServer } from '../../../../services/logging';

const { Title } = Typography;

class VettingCalendar extends Component {
  state = {
    loading: false,
    allowed: null,
    calendar: {},
    timezones: ['America/Los_Angeles'],
    activeTimezone: 'America/Los_Angeles',
    UTCTimes: [],
    times: []
  };

  componentDidMount () {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    if (moment.tz.guess() !== 'America/Los_Angeles') {
      this.setState({
        timezones: ['America/Los_Angeles', moment.tz.guess()],
        activeTimezone: moment.tz.guess()
      });
    }
    this.loadData();
  }

  loadData = () => {
    const { calId } = this.props;
    if (!calId) return;
    this.setState({ loading: true });
    axios
      .post(`${ApiConstant.BASE_URL}calendar/`, {
        action: 'GET_CALENDAR_DETAILS',
        calId
      })
      .then((res) => res.data)
      .then(({ success, result }) => {
        if (success) {
          this.setState(
            (state) => ({ ...state, ...result }),
            () => this.refreshTimes()
          );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => this.setState((state) => ({ ...state, loading: false })));
  };

  handleTimezoneChange = (timezone) => {
    this.setState({ activeTimezone: timezone }, () => this.refreshTimes());
  };

  refreshTimes = () => {
    const timezone = this.state.activeTimezone;
    const times = this.state.UTCTimes.reduce((times, time) => {
      const start_date = moment.utc(time.start_date).tz(timezone);
      times.push({
        start_date: start_date.format('YYYY-MM-DD'),
        end_date: start_date.format('YYYY-MM-DD'),
        times: [start_date.format('HH:mm')]
      });
      return times;
    }, []);
    this.setState({ times });
  };

  handleScheduleEvent = (data, callback) => {
    const { calId } = this.props;
    const { activeTimezone } = this.state;
    if (!calId) return;
    this.setState({ loading: true });
    axios
      .post(`${ApiConstant.BASE_URL}calendar/`, {
        action: 'POST_SCHEDULE_EVENT',
        ...data,
        timezone: activeTimezone,
        calId
      })
      .then((res) => res.data)
      .then(({ success, message, showBackButton, slotTaken }) => {
        if (success && this.props.onSuccessfullyScheduled && typeof this.props.onSuccessfullyScheduled === 'function') {
          const MeetingDateTime = moment.utc(data.utc_date, 'YYYY-MM-DD HH:mm:ss').tz(this.state.activeTimezone);
          // [LOGGING] TI_MeetingBooked
          pushLog2DV2LogServer.info('SEGMENTIO', 'TI_MeetingBooked', {}, {
            utc_date: data.utc_date,
            MeetingBooked: MeetingDateTime.format('LLLL'),
            MeetingTime: MeetingDateTime.format('LT'),
            MeetingDate: MeetingDateTime.format('L'),
            MeetingTimezone: this.state.activeTimezone,
            calendar_id: calId
          });
          this.props.onSuccessfullyScheduled(`Successfully event scheduled at ${moment.utc(data.utc_date, 'YYYY-MM-DD HH:mm:ss').tz(this.state.activeTimezone).format('LLLL')} timezone: ${this.state.activeTimezone}.`);
        }
        if (typeof callback === 'function') callback(success, message, showBackButton, slotTaken);
      })
      .catch((error) => {
        // [LOGGING] CALENDAR_BOOK_FAIL
        pushLog2DV2LogServer.error('SEGMENTIO', 'CALENDAR_BOOK_FAIL', {}, { utc_date: data.UTCDate }, error);
        console.error(error);
      })
      .finally(() => this.setState((state) => ({ ...state, loading: false })));
  };

  render () {
    const { loading, calendar, times, timezones, activeTimezone, allowed } = this.state;
    if (!loading && (!calendar || !calendar.cal_id)) {
      return (
        <div>
          Please contact support@turing.com.
        </div>
      );
    }
    return (
      <Spin spinning={loading}>
        <VettingCalendarUI
          dataSource={times}
          title={calendar && calendar.title}
          name={calendar && calendar.owner_name}
          time={`${calendar && calendar.duration} min`}
          description={calendar && calendar.intro}
          timezones={timezones}
          activeTimezone={activeTimezone}
          onTimezoneChange={this.handleTimezoneChange}
          onScheduleEvent={this.handleScheduleEvent}
          allowed={allowed}
        />
      </Spin>
    );
  }
}

VettingCalendar.propTypes = {
  calId: PropTypes.number.isRequired,
  onSuccessfullyScheduled: PropTypes.func
};

class VettingCalendarUI extends Component {
  state = {
    step: 'choose-time',
    message: '',
    loading: false,
    slotTaken: false,
    showBackButton: false
  };

  bind = (name, options = {}) => {
    /* @Wassim: I DID A QUICK FIX FOR THE LAGG ISSUE HERE, PLEASE CHANGE IT TO A PROPER IMPLEMENTATION */
    let bindObject;
    if (name !== 'role_description' && name !== 'prefer') {
      bindObject = {
        value: this.state[name],
        onChange: (e) => {
          let value = e;
          if (e && typeof e === 'object' && 'target' in e) {
            value = e.target.value;
          }
          this.setState({ [name]: value }, options.onChange);
        }
      };
    } else {
      bindObject = {
        defaultValue: this[name],
        onChange: (e) => {
          let value = e;
          if (e && typeof e === 'object' && 'target' in e) {
            value = e.target.value;
          }
          this[name] = value;
          if (this.timer) clearTimeout(this.timer);
          this.timer = setTimeout(() => this.setState({ [name]: this[name] }), 500);
        },
        onBlur: (e) => {
          this.setState({ [name]: this[name] });
        }
      };
    }
    /*******************/

    return bindObject;
  };

  handleSubmit = () => {
    if (!this.props.onScheduleEvent) {
      return false;
    }
    this.setState({ loading: true, slotTaken: false });
    const UTCDate = moment(
      this.state.date,
      'YYYY-MM-DD HH:mm:ss',
      this.props.activeTimezone
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');

    // [LOGGING] CALENDAR_CONFIRM_BOOK
    pushLog2DV2LogServer.info('SEGMENTIO', 'CALENDAR_CONFIRM_BOOK', {}, { utc_date: UTCDate }, null);

    this.props.onScheduleEvent(
      {
        utc_date: UTCDate,
        role_description: this.state.role_description || '',
        prefer: this.state.prefer || ''
      },
      (success, message, showBackButton, slotTaken) => {
        this.setState({ loading: false, success, step: success ? 'success' : 'error', message, showBackButton, slotTaken });
        if (success) {
          // [LOGGING] CALENDAR_BOOK_SUCCESS
          pushLog2DV2LogServer.info('SEGMENTIO', 'CALENDAR_BOOK_SUCCESS', {}, { utc_date: UTCDate }, null);
        } else {
          // [LOGGING] CALENDAR_BOOK_FAIL
          pushLog2DV2LogServer.error('SEGMENTIO', 'CALENDAR_BOOK_FAIL', {}, { utc_date: UTCDate }, { message });
        }
      }
    );
  };

  render () {
    let { step, date, loading, message, showBackButton, slotTaken } = this.state;
    let errorTitle = null;
    if (this.props.allowed === false) {
      step = 'error';
      errorTitle = 'Action not allowed';
      message = 'You\'re not allowed to book an interviewer at the moment, please contact support';
      showBackButton = false;
    }

    return (
      <Spin spinning={loading}>
        <div className="vetting-calendar-wrapper">
          <div className="vetting-calendar">
            <div
              className={`vetting-calendar-container ${
                step === 'choose-time' ? 'active-calendar-container' : ''
              }`}
            >
              <VettingCalendarDetailsSection
                name={this.props.name}
                title={this.props.title}
                time={this.props.time}
                description={this.props.description}
              />
              <VettingCalendarBookingSection
                dataSource={this.props.dataSource}
                timezones={this.props.timezones}
                activeTimezone={this.props.activeTimezone}
                onTimezoneChange={this.props.onTimezoneChange}
                {...this.bind('date', {
                  onChange: () => this.setState({ step: 'complete-details' })
                })}
              />
            </div>
            <div
              className={`vetting-calendar-container ${
                step === 'complete-details' ? 'active-calendar-container' : ''
              }`}
            >
              <div className="vetting-calendar-details-section">
                <IconButton
                  onClick={() => this.setState({ step: 'choose-time' })}
                >
                  <ArrowBackIosIcon />
                </IconButton>
                <h2>{this.props.name}</h2>
                <h1>{this.props.title}</h1>
                <h3>{this.props.time}</h3>
                <h2 style={{ color: 'green' }}>
                  <div>
                    {moment(date, 'YYYY-MM-DD HH:mm:ss').format('LLLL')}
                  </div>
                  <small>{this.props.activeTimezone}</small>
                </h2>
              </div>
              <div className="vetting-calendar-details-section">
                <Form.Item label="Describe the type of role" help={ (this.state.role_description || '').length >= 900 ? 'The maximum allowed length is 900 characters' : null } >
                  <Input.TextArea
                    {...this.bind('role_description')}
                    placeholder="Describe the type of role that you believe you are best suited for *"
                    maxLength={900} /* 900 not 1000 because the "new line" is counted in Input.TextArea 1 but in mysql 2 ( "\n" )  */
                  />
                </Form.Item>
                <Form.Item label="What technologies or languages you prefer for the interview" help={ (this.state.prefer || '').length >= 200 ? 'The maximum allowed length is 200 characters' : null }>
                  <Input
                    {...this.bind('prefer')}
                    placeholder="What technologies or languages you prefer for the interview"
                    maxLength={200}
                  />
                </Form.Item>
                <div>
                  <Button type="primary" onClick={this.handleSubmit}>
                    Schedule Event
                  </Button>
                </div>
              </div>
            </div>
            <div
              className={`vetting-calendar-container ${
                step === 'success' ? 'active-calendar-container' : ''
              }`}
            >
              <div
                className="vetting-calendar-details-section"
                style={{ width: '100%' }}
              >
                <Alert
                  style={{ margin: 0 }}
                  message="Successfully event scheduled"
                  description={`Successfully event scheduled at ${moment(
                    date,
                    'YYYY-MM-DD HH:mm:ss'
                  ).format('LLLL')} timezone: ${this.props.activeTimezone}.`}
                  type="success"
                  showIcon
                />
              </div>
            </div>
            <div
              className={`vetting-calendar-container ${
                step === 'error' ? 'active-calendar-container' : ''
              }`}
            >
              <div
                className="vetting-calendar-details-section"
                style={{ width: '100%' }}
              >
                {errorTitle === 'Action not allowed'
                  ? <BookedEventUnavailable />
                  : (
                    <Alert
                      style={{ margin: 0 }}
                      message={errorTitle || 'Error when scheduling event'}
                      description={slotTaken
                        ? <span>The time slot you chose <i>just</i> got taken up by another interviewee. Please choose another interview slot.</span>
                        : message}
                      type="error"
                      showIcon
                    />
                  )}
                {showBackButton ? <Button style={{ marginTop: 15 }} onClick={() => this.setState({ step: 'choose-time' })}>Choose another slot</Button> : null}
              </div>
            </div>
          </div>
        </div>
      </Spin>
    );
  }
}

VettingCalendarUI.propTypes = {
  onScheduleEvent: PropTypes.func.isRequired,
  activeTimezone: PropTypes.string.isRequired,
  name: PropTypes.string,
  title: PropTypes.string,
  time: PropTypes.string,
  description: PropTypes.string,
  dataSource: PropTypes.array,
  timezones: PropTypes.array,
  allowed: PropTypes.any,
  onTimezoneChange: PropTypes.func
};

function VettingCalendarDetailsSection (props) {
  return (
    <div className="vetting-calendar-details-section">
      <h2>{props.name}</h2>
      <h1>{props.title}</h1>
      <h3>{props.time}</h3>
      <div dangerouslySetInnerHTML={{ __html: props.description }} />
    </div>
  );
}

VettingCalendarDetailsSection.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  time: PropTypes.string,
  description: PropTypes.string
};

function VettingCalendarBookingSection ({
  value,
  onChange,
  dataSource,
  timezones,
  activeTimezone,
  onTimezoneChange
}) {
  const date = value && moment().utc(value);
  let [state, setState] = useState({
    date: date && date.format('YYYY-MM-DD'),
    time: date && date.format('HH:mm')
  });
  state.set = (obj = {}) => {
    state = { ...state, ...obj };
    setState(state);
  };
  state.bind = (name, options = {}) => {
    const { bindProp = 'value' } = options;
    return {
      [bindProp]: state[name] || null,
      onChange: (value) => {
        state.set({ [name]: value });
        if (options.onChange) options.onChange();
      }
    };
  };

  useEffect(() => {
    if (value) {
      state.set({
        date: moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
        time: moment(value, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
      });
    }
  }, [value]);

  const handleConfirm = () =>
    onChange && onChange(`${state.date} ${state.time}:00`);

  const times = useMemo(() => {
    if (state.date && Array.isArray(dataSource)) {
      let times = dataSource.reduce((times, item) => {
        if (
          moment.utc(state.date).isSameOrAfter(moment.utc(item.start_date)) &&
          moment.utc(state.date).isSameOrBefore(moment.utc(item.end_date))
        ) {
          times = [...times, ...item.times];
        }
        return times;
      }, []);

      times = times.map((time) => ({ time, value: +time.replace(':', '.') }));
      times.sort((a, b) => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      });
      return times.map(({ time }) => time);
    }
    return [];
  }, [state.date, dataSource]);

  return (
    <div className="vetting-calendar-right-section">
      <div className="vetting-calendar-booking-section">
        <h1>Select a Date & Time</h1>
        <VettingCalendarView {...state.bind('date')} dataSource={dataSource} />
        <div className="vetting-calendar-timezone">
          <span>Timezone : </span>
          <Select value={activeTimezone} onChange={onTimezoneChange}>
            {(timezones || []).map((tz) => (
              <Select.Option key={tz}>{tz}</Select.Option>
            ))}
          </Select>
        </div>
      </div>
      <div
        className={`vetting-calendar-booking-time-section ${
          state.date ? 'open' : 'close'
        }`}
      >
        {state.date
          ? (
            <VettingCalendarTimeView
              date={state.date}
              times={times}
              {...state.bind('time', { onChange: handleConfirm })}
            />
          )
          : null}
      </div>
    </div>
  );
}

VettingCalendarBookingSection.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  dataSource: PropTypes.array,
  timezones: PropTypes.array,
  activeTimezone: PropTypes.string,
  onTimezoneChange: PropTypes.func
};

function VettingCalendarTimeView ({ times, value, onChange }) {
  let [state, setState] = useState({
    times: (times || []).map((time) => ({ time }))
  });

  useEffect(() => {
    setState({ times: (times || []).map((time) => ({ time })) });
  }, [times]);

  state.set = (obj = {}) => {
    state = { ...state, ...obj };
    setState(state);
  };

  state.times.map((item) => {
    item.select = () => {
      state.times.forEach((elm) => {
        elm.active = false;
      });
      item.active = true;
      state.set();
    };
    item.confirm = () => {
      if (onChange && item.active) onChange(item.time);
    };
  });

  useEffect(() => {
    state.times
      .filter((item) => item.time === value)
      .map((item) => item.select());
  }, [value]);

  return (
    <div>
      <small>{'Times you\'re available'}</small>
      <div className="times-list">
        {state.times.map((item, i) => (
          <TimeItem key={i} item={item} />
        ))}
      </div>
    </div>
  );
}

VettingCalendarTimeView.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  times: PropTypes.array
};

function TimeItem ({ item }) {
  return (
    <div
      onClick={item.select}
      className={`btn-time ${item.active ? 'active-time' : 'not-active-time'}`}
    >
      <div className="btn-time-label">{item.time}</div>
      <div className="btn-time-confirm" onClick={item.confirm}>
        Confirm
      </div>
    </div>
  );
}

TimeItem.propTypes = {
  item: PropTypes.object
};

function VettingCalendarView ({ renderItem, value, onChange, dataSource = [] }) {
  const names = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  const allowed = Array.isArray(dataSource)
    ? dataSource
      .filter(({ times }) => times && times.length)
      .map(({ start_date, end_date }) => [start_date, end_date])
    : [];
  const getFirstAllwedDateInFuture = () => {
    if (Array.isArray(allowed) && allowed.length > 0) {
      return (
        allowed.reduce((d, [date1, date2]) => {
          if (moment.utc().isBefore(moment.utc(date1), 'date')) {
            if (!d) {
              return moment.utc(date1);
            } else if (d.isBefore(moment.utc(date1), 'date')) {
              return moment.utc(date1);
            } else {
              return moment.utc();
            }
          }
          return d;
        }, null) || moment.utc()
      );
    }
    return moment.utc();
  };

  let [state, setState] = useState({
    month: getFirstAllwedDateInFuture().format('YYYY-MM')
  });
  state.set = (obj = {}) => {
    state = { ...state, ...obj };
    setState(state);
  };

  const checkDateInRange = (date, range) => {
    if (Array.isArray(range) && range.length === 2) {
      const [date1, date2] = range;
      return (
        date.isSameOrAfter(moment.utc(date1), 'date') &&
        date.isSameOrBefore(moment.utc(date2), 'date')
      );
    }
    return false;
  };

  const checkIfAllowedDate = (date) => {
    if (moment.utc().startOf('day').isAfter(date)) return false;
    if (Array.isArray(allowed)) {
      return !!allowed.find((range) => checkDateInRange(date, range));
    }
    return false;
  };
  const getWeeksArray = (year, month) => {
    const monthIndex = month - 1;
    const date = moment.utc([year, monthIndex, 1, 0, 0, 0]);
    const result = [];
    let week = [];
    while (date.month() === monthIndex) {
      week.push({
        date: moment(date.toJSON()),
        isActiveMonth: true,
        day: date.day()
      });
      if (date.day() === 0) {
        // if (result.length === 0) {
        //   if (week.length < 7) {
        //     const i = 7 - week.length;
        //     for (let j = 1; j <= i; j++) {
        //       const date1 = moment.utc([year, monthIndex, 1, 0, 0, 0]);
        //       date1.add(-j, 'day');
        //       week.unshift({
        //         date: moment(date1.toJSON()),
        //         isActiveMonth: false,
        //         day: date1.day()
        //       });
        //     }
        //   }
        // }
        result.push([...week]);
        week = [];
      }
      date.add(1, 'day');
    }
    if (week.length > 0) {
      // const i = 7 - week.length;
      // for (let j = 0; j < i; j++) {
      //   const date1 = moment(date.toJSON());
      //   date1.add(j, 'day');
      //   week.push({
      //     date: moment(date1.toJSON()),
      //     isActiveMonth: false,
      //     day: date1.day()
      //   });
      // }
      result.push([...week]);
    }
    return result;
  };
  const date = moment.utc(state.month);
  const weeks = getWeeksArray(date.year(), date.month() + 1);

  const canGoToPrevMonth = () => {
    if (Array.isArray(allowed)) {
      const prevMonth = moment
        .utc(date.toJSON())
        .add(-1, 'month')
        .endOf('month');
      return (
        moment.utc().isSameOrBefore(prevMonth, 'date') &&
        !!allowed
          .filter((range) => Array.isArray(range) && range.length === 2)
          .find(([date1, date2]) => {
            return moment.utc(date1).isSameOrBefore(prevMonth);
          })
      );
    }
    return false;
  };

  const canGoToNextMonth = () => {
    if (Array.isArray(allowed)) {
      const nextMonth = moment.utc(date.toJSON()).add(1, 'month');
      return !!allowed
        .filter((range) => Array.isArray(range) && range.length === 2)
        .find(([date1, date2]) => {
          return moment.utc(date2).isSameOrAfter(nextMonth);
        });
    }
    return false;
  };

  const goToPrevMonth = () => {
    if (!canGoToPrevMonth()) return;
    state.set({
      month: moment
        .utc(date.toJSON())
        .add(-1, 'month')
        .format('YYYY-MM')
    });
  };

  const goToNextMonth = () => {
    if (!canGoToNextMonth()) return;
    state.set({
      month: moment
        .utc(date.toJSON())
        .add(1, 'month')
        .format('YYYY-MM')
    });
  };

  let allBooked = true;
  const initItem = (item) => {
    item.enable = checkIfAllowedDate(item.date);
    if (item.enable) {
      allBooked = false;
    }

    item.active =
      value &&
      moment.utc(value).format('YYYY-MM-DD') === item.date.utc().format('YYYY-MM-DD');
    item.select = () => {
      if (!item.enable) return;
      if (onChange) onChange(item.date.format('YYYY-MM-DD'));
    };
    return item;
  };

  const renderDayItem = renderItem || ((item) => {
    return (
      <div
        className={`${item.enable ? 'enable' : 'disable'} ${
              item.active ? 'selected' : ''
            }`}
        onClick={item.select}
      >
        {item.date.utc().format('DD')}
        { item.date.isSame(new Date(), 'day') ? <span className="vetting-calendar-dot-current-date"></span> : null}
      </div>
    );
  });

  return (
    <div className="vetting-calendar-view">
      <div className="vetting-calendar-view-nav">
        <b>{date.format('MMMM YYYY')}</b>
        <span
          className={`${canGoToPrevMonth() ? 'enable-btn' : 'disable-btn'}`}
          onClick={goToPrevMonth}
        >
          <ArrowBackIosIcon />
        </span>
        <span
          className={`${canGoToNextMonth() ? 'enable-btn' : 'disable-btn'}`}
          onClick={goToNextMonth}
        >
          <ArrowForwardIosIcon />
        </span>
      </div>
      <div className="week-day-names">
        {names.map((name) => (
          <div key={name}>{name}</div>
        ))}
      </div>
      {weeks.map((week, i) => (
        <div key={i} className="week-day-dates">
          {week.map(initItem).map((item) => (
            <div
              key={item.date.format('YYYY-MM-DD')}
              className={`vetting-calendar-view-day-item grid-column-${
                item.day
              } ${
                item.isActiveMonth
                  ? 'vetting-calendar-view-item-activemonth'
                  : 'vetting-calendar-view-item-notactivemonth'
              }`}
            >
              {renderDayItem(item)}
            </div>
          ))}
        </div>
      ))}
      { allBooked ? <div className="vetting-calendar-all-booked"><span>We are fully booked, please check the next month</span></div> : null }
    </div>
  );
}

VettingCalendarView.propTypes = {
  renderItem: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func,
  dataSource: PropTypes.array
};

function BookedEventUnavailable (props) {
  return (
    <Card>
      <Row>
        <Col>
          <div style={{ color: '#c71d1d' }}>UNAVAILABLE YET</div>
        </Col>
        <Col>
          <Title level={4}>Live Coding Challenge</Title>
        </Col>
        <Col>
          <Row type="flex" justify="space-between" align="bottom">
            <Col span={15}>
              <p>
                Please meet the following requirements to unlock the Live Coding Challenge:<br/>
                &bull;&#09; Complete all required fields in the Profile.<br/>
                &bull;&#09; Complete the work experience survey in the Tests.<br/>
                &bull;&#09; Complete all required Tests. <br/>
                &bull;&#09; You must have at least 3 years of professional experience.<br/>
                &bull;&#09; If you have cancelled / rescheduled your Live Coding Challenge twice, you are not permitted to reschedule again. <br/>
                <small>If you believe there has been a mistake, please contact us at: support@turing.com</small>
              </p>
              {/*
              <p>
                &bull;&#09;Your current progress has not yet met the requirements<br/>
                to book an interview with us.<br/>
                &bull;&#09;Your year of experience has not yet met the requirements<br/>
                at the moment.<br/>
                &bull;&#09;Make sure you have completed and passed all required Tests<br/>
                before reaching this step.<br/>
                &bull;&#09;If you have reached the Cancel/Reschedule limit, you are not permitted to reschedule again<br/>
                <small>If you believe there has been a mistake, please contact us at: support@turing.com</small>
              </p>
*/}
            </Col>
            <Col>
              <img src={eventIcon} alt="icon" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
}

export default VettingCalendar;
